import { createQuery } from "@/api/utils";
import {
    Company,
    CompanyFile,
    CompanySearchResult,
    CompanyConnector,
} from "./Company.types";

export const getCompany = createQuery<Company, { uuid?: string }>(
    ({ api, router, params, session }) => {
        const companyId =
            params?.uuid ||
            router.params.companyUUID ||
            router.params.companyId ||
            session.user?.organizationId;

        return api.get(`/backend/v2/companies/${companyId}`);
    },
);

export const searchCompanies = createQuery<
    {
        results: CompanySearchResult[];
        pagination: {
            numPages: number;
            pageNumber: number;
            pageSize: number;
            totalResults: number;
        };
    },
    {
        query: string;
        page?: number;
        pageSize?: number;
    }
>(({ api, params }) => {
    const page = params.page || 1;
    const pageSize = params.pageSize || 10;

    return api
        .get(
            `/backend/companies/search?order=updated_at&q=${params.query}&page=${page}&num_pages=1&page_size=${pageSize}&company_type=company`,
        )
        .then((res) => ({
            results: res.results,
            pagination: res.pagination,
        }));
});

export const getCompanyFiles = createQuery<CompanyFile[], { uuid?: string }>(
    ({ api, params, router, session }) => {
        const companyId =
            params?.uuid ||
            router.params.companyUUID ||
            session.user?.organizationId;
        return api
            .get(`/backend/v2/companies/${companyId}/files`)
            .then((res) => res);
    },
);

export const getCompanyFile = createQuery<
    CompanyFile,
    { uuid?: string; fileId: number }
>(({ api, params, router, session }) => {
    const companyId =
        params?.uuid ||
        router.params.companyUUID ||
        session.user?.organizationId;

    return api
        .get(
            `/backend/v2/companies/${companyId}/files/${params.fileId}/download`,
        )
        .then((res) => ({ ...res, download: res.downloadUrl }));
});

export const getCompanyConnectors = createQuery<
    CompanyConnector[],
    { uuid?: string }
>(({ api, params, router, session }) => {
    const companyId =
        params?.uuid ||
        router.params.companyUUID ||
        session.user?.organizationId;
    return api.get(`/backend/v2/companies/${companyId}/connectors`, { params });
});
